import { getCsrfValue } from "~/common/utils/ApiHelper";
import type { CartSimulationEntry, CartSimulationRequest, CartSimulationResponseItem } from "~/domains/cart/types";
import { resolveApiUrl } from "~/utils/url/urlResolver";

const simulateCartUrl = resolveApiUrl("/cart/simulate");

type SimulationResponseDTO = {
  results: CartSimulationResponseItem[];
  quantityAdjusted: boolean;
};

export async function simulateCart(entries: CartSimulationEntry[], signal?: AbortSignal) {
  const body: CartSimulationRequest = {
    items: entries,
  };

  const response = await fetch(simulateCartUrl, {
    body: JSON.stringify(body),
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    method: "POST",
    mode: "cors",
    redirect: "follow",
    signal,
  });

  if (!response.ok) {
    throw new Error(`Cart simulate failed with status ${response.status}`);
  }

  return (await response.json()) as SimulationResponseDTO;
}
